import * as React from 'react'
import ChatbotWrapper from '../../../components/ChatbotWrapper'
import Section from '../../../components/Section'
import styles from './styles.module.scss'
import { faDownload } from '@fortawesome/free-solid-svg-icons'

import API from '../../../api'
import { ifElse } from '../../../utilities'
import Markdown from 'react-markdown'
import { RainbowText } from '../../../components/RainbowText'
import { LargeRainbowButton } from '../../../components/RainbowButton'
import { useLocation } from 'react-router'

type VersionInfo = { version: string; rc?: number; link: string; changelog: { features: string; updates: string; fixes: string } }

const getDownloadInfo = async (allowRC?: boolean) => {
  try {
    const response = await API.getDownloadInfo(allowRC)
    const { version, link, features, updates, fixes, rc } = response
    return { version, rc, link, changelog: { features, updates, fixes } }
  } catch (e) {
    return undefined
  }
}

const Download: React.FC = () => {
  const [info, setInfo] = React.useState<VersionInfo>()
  const location = useLocation()
  React.useEffect(() => {
    const params = new URLSearchParams(location.search)
    const getInfo = async () => {
      const versionInfo = await getDownloadInfo(params.get('allowRC') === 'true')
      setInfo(versionInfo)
      // if (versionInfo?.link) {
      //   // setTimeout(() => window.location.assign(versionInfo.link), 0)
      //   // window.open(versionInfo.link, '_blank', 'noopener,noreferrer')
      //   const iframe = document.createElement('iframe')
      //   iframe.style.display = 'none'
      //   iframe.src = versionInfo.link
      //   document.body.appendChild(iframe)
      // }
    }
    getInfo()
  }, [location])

  const RainbowTextWrapper: React.FC<React.PropsWithChildren> = ({ children }) => {
    return (
      <p>
        <RainbowText reverse light text={children} />
      </p>
    )
  }

  const DracoBot: React.FC<React.PropsWithChildren<{ reverse?: boolean; light?: boolean }>> = ({ reverse = true, light = true }) => {
    return <RainbowText light={light} reverse={reverse} text='Draco.Bot' />
  }

  const versionNumber = () => {
    if (!info) return
    return 'v' + info.version + (info.rc ? '-rc' + info.rc : '')
  }

  return (
    <ChatbotWrapper
      decorate
      title={`Draco.Bot ${versionNumber()} Release Notes`}
      titleClassName={styles.center}
      header={ifElse(
        info,
        <div className={styles.buttons}>
          <LargeRainbowButton icon={faDownload} href={info?.link}>
            Download
            <br />
            <DracoBot /> {versionNumber()}
          </LargeRainbowButton>
        </div>,
        <>Loading, please wait...</>,
      )}
    >
      <div className={styles.container}>
        {ifElse(
          info,
          <>
            {ifElse(
              info?.changelog.features,
              <Section containerClassName={styles.marked} title={`Features`} icon={<span className={styles.icon}>🎉</span>}>
                <Markdown components={{ h3: RainbowTextWrapper }}>{info?.changelog.features.replaceAll('•', '*')}</Markdown>
              </Section>,
              null,
            )}
            {ifElse(
              info?.changelog.updates,
              <Section containerClassName={styles.marked} title={`Updates`} icon={<span className={styles.icon}>🆕</span>}>
                <Markdown components={{ h3: RainbowTextWrapper }}>{info?.changelog.updates.replaceAll('•', '*')}</Markdown>
              </Section>,
              null,
            )}
            {ifElse(
              info?.changelog.fixes,
              <Section containerClassName={styles.marked} title={`Fixes`} icon={<span className={styles.icon}>🐞</span>}>
                <Markdown components={{ h3: RainbowTextWrapper }}>{info?.changelog.fixes.replaceAll('•', '*')}</Markdown>
              </Section>,
              null,
            )}
          </>,
          <div>Loading Version Information, Please Wait...</div>,
        )}
      </div>
    </ChatbotWrapper>
  )
}

export default Download
